module.exports = __webpack_public_path__ + "img/38.fcd952a8.png";